export default __webpack_public_path__ + "static/media/share.257e07e3.svg";